import React, { useState } from 'react';
import Navigation from './components/Navigation';
import CalculatorView from './components/CalculatorView';
import SearchView from './components/SearchView';
import DocumentUploadView from './components/DocumentUploadView';

function App() {
  const [activeView, setActiveView] = useState('calculator');

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation activeView={activeView} setActiveView={setActiveView} />
      {activeView === 'calculator' && <CalculatorView />}
      {activeView === 'search' && <SearchView />}
      {activeView === 'upload' && <DocumentUploadView />}
    </div>
  );
}

export default App;
